export default "__VITE_ASSET__BzH6ysIz__"